import { useSelector, useDispatch } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { DYNAMIC_STEPS_CONFIG } from '../../../../config/dataConfig/FJHeadshotGeneratorData';
import FJHeadshotContinueButton from '../view/FJHeadshotContinueButton';
import FJActionHeadshotGenerator from '../../../../redux/action/FJActionHeadshotGenerator';

const FJHeadshotContinueButtonContainer = () => {
    const dispatch = useDispatch();
    // 从 Redux store 获取状态

    const selectedBackgroundPreference = useSelector(state => state.headshotGenerator.selectedBackgroundPreference);
    const selectedTheme = useSelector(state => state.headshotGenerator.selectedTheme);
    const selectedCategory = useSelector(state => state.headshotGenerator.selectedCategory);
    const currentStepIndex = useSelector(state => state.headshotGenerator.currentStepIndex);
    const unitPrice = useSelector(state => state.headshotGenerator.unitPrice);
    const totalOutput = useSelector(state => state.headshotGenerator.totalOutput);
    const imageUploadStatus = useSelector(state => state.headshotGenerator.imageUploadStatus);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const taskStatus = useSelector(state => state.common.taskStatus);
    // 获取当前步骤信息
    const steps = useMemo(() => DYNAMIC_STEPS_CONFIG[selectedCategory] || [], [selectedCategory]);

    const handleNext = useCallback(() => {
        dispatch(FJActionHeadshotGenerator.goNextStepAction());
    }, [dispatch]);

    const handleGenerate = useCallback(() => {
        dispatch(FJActionHeadshotGenerator.onGenerationAction());
    }, [dispatch]);

    return (
        <FJHeadshotContinueButton
            selectedBackgroundPreference={selectedBackgroundPreference}
            selectedTheme={selectedTheme}
            onNext={handleNext}
            steps={steps}
            currentStepIndex={currentStepIndex}
            onGenerate={handleGenerate}
            taskStatus={taskStatus}
            unitPrice={unitPrice}
            totalOutput={totalOutput}
            isProjectLoading={isProjectLoading}
            imageUploadStatus={imageUploadStatus}
        />
    );
};

export default FJHeadshotContinueButtonContainer;
